import { format, isThisYear, isToday, isYesterday } from 'date-fns';

import {
  applicantStatusTypes,
  applicationStatusTypes,
  uiApplicationStatusTypes,
} from '../../../../../../../constants/statusConstants';
import { getTitleCase } from '../../../../../../../utils/formatLogicUtil';

function formatDate(timestamp) {
  if (isToday(timestamp)) {
    return `today, ${format(new Date(timestamp), 'h:mm A')}`;
  }
  if (isYesterday(timestamp)) {
    return `yesterday, ${format(new Date(timestamp), 'h:mm A')}`;
  }
  if (isThisYear(timestamp)) {
    return format(new Date(timestamp), 'MMM DD, h:mm A');
  }
  return format(new Date(timestamp), 'MMM DD, YYYY, h:mm A');
}

export function findMostRecentApplicant(applicants) {
  if (applicants === null || typeof applicants === 'undefined') {
    return {};
  }

  const nonWithdrawnApplicants = applicants.filter(
    (applicant) => applicant.status !== applicantStatusTypes.WITHDRAWN.id,
  );

  if (nonWithdrawnApplicants.length === 0) {
    return {};
  }

  const submittedApplicants = nonWithdrawnApplicants.filter(
    (applicant) => applicant.status === applicantStatusTypes.COMPLETED.id,
  );
  const mostRecentApplicant = submittedApplicants.reduce((prev, curr) => {
    return prev.submitDate > curr.submitDate ? prev : curr;
  }, {});

  return mostRecentApplicant;
}

export function getIsCompletedOrInProgress(type) {
  return (
    type === uiApplicationStatusTypes.COMPLETED.id ||
    type === uiApplicationStatusTypes.IN_PROGRESS.id ||
    type === applicationStatusTypes.ACCEPTED.id ||
    type === applicationStatusTypes.INVITED_TO_MOVE_IN.id ||
    type === applicationStatusTypes.CONDITIONALLY_APPROVED.id
  );
}

function getApplicationStatus({ application, type }) {
  const { applicants, acceptedDate, declinedDate, withdrawDate, mergedDate, conditionallyApprovedDate } = application;

  let update = null;
  if (type === applicationStatusTypes.ACCEPTED.id || type === applicationStatusTypes.INVITED_TO_MOVE_IN.id) {
    update = `Approved ${formatDate(acceptedDate)}`;
  } else if (conditionallyApprovedDate) {
    const displayDate = formatDate(conditionallyApprovedDate);
    update = `Conditionally approved ${displayDate}`;
  } else if (mergedDate) {
    const displayDate = formatDate(mergedDate);
    update = `Combined ${displayDate}`;
  } else if (type === uiApplicationStatusTypes.COMPLETED.id || type === uiApplicationStatusTypes.IN_PROGRESS.id) {
    const mostRecentApplicant = findMostRecentApplicant(applicants);
    const mostRecentSubmitTime = mostRecentApplicant.submitDate;
    update =
      applicants.length > 1
        ? `${getTitleCase(mostRecentApplicant.firstName)} last applied ${formatDate(mostRecentSubmitTime)}`
        : `Applied ${formatDate(mostRecentSubmitTime)}`;
  } else if (type === uiApplicationStatusTypes.WITHDRAWN.id) {
    update = `Withdrawn ${formatDate(withdrawDate)}`;
  } else if (type === uiApplicationStatusTypes.DECLINED.id) {
    update = `Declined ${formatDate(declinedDate)}`;
  } else if (type === uiApplicationStatusTypes.INVITED.id) {
    const displayDate = formatDate(applicants[0].invitationDate);
    update = `Invited ${displayDate}`;
  }

  return update;
}

export { getApplicationStatus, formatDate };
